<template>
  <div class="body">
    <div class="app">
      <span class="text">蒙正课堂客资收集系统</span>
    </div>
    <div class="bodyy">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="类型：">
          <el-radio-group
            v-model="radio"
            @change="handleChange"
            style="margin-top: 5px; margin-right: 77%"
          >
            <el-radio label="1">微信号</el-radio>
            <el-radio label="2">微信二维码</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="showWxInput" label="微信：" prop="customerWx">
          <el-input
            @input="limitation"
            v-model="ruleForm.customerWx"
            placeholder="请输入微信号"
            style="width: 100%"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="微信二维码："
          class="screenshot"
          prop="weixina"
          v-if="showQrCode"
          style="margin-right: 80%"
        >
          <el-upload
            class="avatar-uploader"
            ref="upload_wx"
            action="#"
            :on-remove="handleRemove_wx"
            :before-upload="beforeUpload_wx"
            :file-list="fileList_wx"
            :http-request="handleUpload_wx"
            :auto-upload="true"
            :on-preview="handlePreview_wx"
            :on-success="handleAvatarSuccess_wx"
            :limit="1"
            accept=".png,.jpg,.pdf"
          >
            <img v-if="weixin" :src="weixin" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="来源：" >
          <span style="color: red;position: absolute;  left: -6px;">*</span>
          <selectcomtent  width="100%" :objUrl="{  tiile:'来源',  selectList:'/customerinformation/sourcelist', keys:'customerSource', }" @handleChangeSelect="handleChangeSelect"></selectcomtent>

          <!-- <el-select
            class="select"
            v-model="ruleForm.customerSource"
            placeholder="请选择来源"
            style="width: 100%"
            filterable
            clearable
          >
            <el-option
              v-for="source in sources"
              :key="source.sourceId"
              :value="source.sourceId"
              :label="source.sourceName"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="来源负责人：" >
           <span style="color: red;position: absolute;  left: -6px;">*</span>
           <selectcomtent  width="100%" :objUrl="{  tiile:'来源负责人',  selectList:'/customerinformation/sourcepeoplelist', keys:'customerSourcePeople', }" @handleChangeSelect="handleChangeSelect"></selectcomtent>

          <!-- <el-select
            class="select"
            v-model="ruleForm.customerSourcePeople"
            placeholder="请选择来源负责人"
            style="width: 100%"
            filterable
            clearable
          >
            <el-option
              v-for="source in sourcesPeople"
              :key="source.sourcepeopleId"
              :value="source.sourcepeopleId"
              :label="source.sourcepeopleName"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="IP老师：" >
          <span style="color: red;position: absolute;  left: -6px;">*</span>
          <selectcomtent  width="100%" :objUrl="{  tiile:'老师',  selectList:'/teacherCustomer/getTeacherList', keys:'customerTeacherid', }" @handleChangeSelect="handleChangeSelect"></selectcomtent>

          <!-- <el-select
            id="teacher"
            class="select"
            v-model="ruleForm.customerTeacherid"
            placeholder="请选择老师"
            style="width: 100%"
            filterable
            clearable
          >
            <el-option
              v-for="teacher in teachers"
              :key="teacher.value"
              :value="teacher.value"
              :label="teacher.label"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="地域：" prop="customerTeacheridd">
          <el-select
            class="select"
            v-model="ruleForm.customerTeacheridd"
            placeholder="请选择地域"
            style="width: 100%"
            filterable
            clearable
          >
            <el-option
              v-for="teacher in teacherss"
              :key="teacher.id"
              :value="teacher.dictType"
              :label="teacher.dictValue"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="渠道：" prop="channelType">
          <el-select
            class="select"
            v-model="ruleForm.channelType"
            placeholder="请选择渠道"
            style="width: 100%"
            filterable
            clearable
          >
            <el-option
              v-for="teacher in channelLsit"
              :key="teacher.dictType"
              :value="teacher.dictType"
              :label="teacher.dictValue">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="流量来源：">
          <el-radio-group  v-model="trafficSource" style="margin-top: 5px; margin-right: 77%" >
            <el-radio label="1">自然流</el-radio>
            <el-radio label="2">付费流</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="添加方式：">
          <el-radio-group
            v-model="add"
            @change="handleChangeadd"
            style="margin-top: 5px; margin-right: 77%"
          >
            <el-radio label="1">主动</el-radio>
            <el-radio label="2" @click="passivity">被动</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分配指定销售：" v-show="showSelect">
          <el-select
            id="teacher"
            class="select"
            v-model="salesteachers"
            placeholder="请选择老师"
            style="width: 100%"
            filterable
            clearable
            :filter-method="handleChangeName"
          >
            <el-option
              v-for="teacher in salesteacher"
              :key="teacher.id"
              :value="teacher.id"
              :label="teacher.label"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="display: flex;">
          <el-form-item style="width: 50%;" label="客资截图(选填)："  class="screenshot"  prop="delivery" >
            <el-upload
              class="avatar-uploader"
              ref="upload"  
              action="#"
              :on-remove="handleRemove"
              :beforeUpload="beforeUpload"
              :file-list="fileList"
              :http-request="handleUpload"
              :auto-upload="true"
              :on-success="handleAvatarSuccess"
              :on-preview="handlePreview"
              :limit="1"
              accept=".png,.jpg,.pdf">
              <img v-if="screenshot" :src="screenshot" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="客户需求：" >
            <el-input type="textarea"  style="width: 450px;"  placeholder="请输入客户需求" :autosize="{ minRows: 6, maxRows: 6 }"  v-model="textareaJson"  maxlength="99999999"  show-word-limit  > </el-input>
          </el-form-item>
        </el-form-item>
        

        <el-form-item>
          <el-button class="btn" type="primary" @click="submitForm('ruleForm')"
            >提交</el-button
          >
        </el-form-item>



      </el-form>
    </div>

    <el-dialog :visible="dialogShow" width="70%" style="padding: 30px;" close-on-press-escape	 :before-close="handlebefore">
        <img :src="handleShowImg" alt="" style="width: 100%;height: 100%;">
    </el-dialog>

  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import loadingUtils from "../utils/loading";
import selectcomtent from "./selectcomtent.vue";

export default {
  components: {
    selectcomtent,
  },
  data() {
    return {
      textareaJson: "",
      imageUrl: `${apiBaseUrl}/customerinformation/importFileEwm`, //微信二维码
      // imageUrl2: `${apiBaseUrl}/customerinformation/importFile`, //客资截图
      imageUrl2: `https://mz-app-develop.oss-cn-beijing.aliyuncs.com`,
      flag: false, //校验标识
      value: "",
      customerSource: "",
      customerSourcePeople: "",
      customerTeacherid: "",
      customerWx: "", // 微信号
      sources: [], //来源
      sourcesPeople: [], //来源负责人
      showSelect: false, // 控制下拉框的显示或隐藏
      teacherss:[
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ],
      channelLsit:[
        {dictValue:"线上", dictType:1 },
        {dictValue:"线下", dictType:2 },
        {dictValue:"转介绍", dictType:3 },
      ],
      teachers: [
        {
          value: 1,
          label: "小单老师",
        },
        {
          value: 2,
          label: "大单老师",
        },
        {
          value: 3,
          label: "刘老师",
        },
        {
          value: 4,
          label: "杨老师",
        },
        {
          value: 5,
          label: "线下老师",
        },
      ], //；老师
      salesteachers: "",
      salesteacher: [
    
      ],
      screenshot: "", // 截图文件
      weixin: "", //二维码文件
      isSubmitted: false, // 默认为未提交状态
      showWxInput: true, // 是否显示微信号输入框
      showQrCode: false, // 是否显示微信二维码上传框
      radio: "1", //默认单选框
      add: "1", //添加方式
      trafficSource:'1',
      customerType: "", //类型：微信号/二维码
      ruleForm: {
        customerWx: "", //微信
        customerSource: "", //来源
        customerSourcePeople: "", //来源负责人
        customerTeacherid: "", //教师
        customerTeacheridd:'',
        weixina: "", //二维码
        channelType: '',
      },
      rules: {
        customerWx: [
          { required: true, message: "请输入微信号", trigger: "blur" },
        ],
        // customerSource: [
        //   { required: true, message: "请选择来源", trigger: "change" },
        // ],
        // customerSourcePeople: [
        //   { required: true, message: "请选择来源负责人", trigger: "change" },
        // ],
        // customerTeacherid: [
        //   { required: true, message: "请选择老师", trigger: "change" },
        // ],
        customerTeacheridd: [
          { required: true, message: "请选择地域", trigger: "change" },
        ],
        channelType: [
          { required: true, message: "请选择渠道", trigger: "change" },
        ],
      },
      fileList:[],
      fileList_wx:[],
      dialogShow: false,
      handleShowImg:"",

    };
  },
  created() {
    //客户来源
    // this.getDataSourse();
    //客户来源负责人
    // this.getDataSoursePeople();
    //老师列表
    this.getDataTeachers();

    this.getcityOptions()

    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
      this.teacherss = res.data.data
    })
  },
  mounted () {
    this.salesteacher = JSON.parse(sessionStorage.getItem('customersaleObj1'))
    axios.post(`${apiBaseUrl}/saleWeight/getSaleList`, { saleName: '' },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
       if (res.data.code == 200) {
         let datas = res.data.data.map(fore => {
             fore.id = fore.telephone
             fore.saleId = fore.saleId
             fore.label = fore.saleName 
             return fore
         })
         this.salesteacher = datas
       }else{
         this.salesteacher = JSON.parse(sessionStorage.getItem('customersaleObj1'))
       }
     })
  },
  methods: {

    handleChangeSelect (keys,value) {
       this.$set(this.ruleForm,keys,value)
       console.log(this.ruleForm,keys,value)
       console.log(this.ruleForm)
    },

    handleChangeName(value) {
      if (value) {
        axios.post(`${apiBaseUrl}/saleWeight/getSaleList`, { saleName: value },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
            let datas = res.data.data.map(fore => {
                fore.id = fore.telephone
                fore.saleId = fore.saleId
                fore.label = fore.saleName 
                return fore
            })
            this.salesteacher = datas
          }else{
            this.salesteacher = JSON.parse(sessionStorage.getItem('customersaleObj1'))
          }
        })
      } else {
        this.salesteacher = JSON.parse(sessionStorage.getItem('customersaleObj1'))
      }
    },


    getcityOptions(){
      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
      { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
      }).then((res)=>{ this.teacherss = res.data.data

      })
    },
    handlebefore(){
      this.handleShowImg = ""
      this.dialogShow = false
    },
    getFileName(name) {
      return name.substring(name.lastIndexOf("."));
    },
    beforeUpload(file) {
      // 限制上传类型
      const fileExtensions =
        this.getFileName(file.name) === ".bmp" ||
        this.getFileName(file.name) === ".tif" ||
        this.getFileName(file.name) === ".gif" ||
        this.getFileName(file.name) === ".pcx" ||
        this.getFileName(file.name) === ".svg" ||
        this.getFileName(file.name) === ".psd" ||
        this.getFileName(file.name) === ".webp" ||
        this.getFileName(file.name) === ".apng" ||
        this.getFileName(file.name) === ".ai" ||
        this.getFileName(file.name) === ".avif" ||
        this.getFileName(file.name) === ".png" ||
        this.getFileName(file.name) === ".pdf"||
        this.getFileName(file.name) === ".jpg";
      //限制的上限为20M
      const max20M = file.size / 1024 / 1024 < 20;
      if (!fileExtensions) {
        this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
      }
      if (!max20M) {
        this.$message.error("上传文件大小不能超过 20MB!");
      }
      return fileExtensions && max20M;
    },
    handleUpload(option) {
      var obj = option.file.name;
      var index = obj.lastIndexOf(".");
      obj = obj.substring(index, obj.length);
      // 生成的文件名，保留文件后缀名，进行拼接
      let objName = getFileNameUUID() + this.getFileName(option.file.name);
      // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
      put(`mz_pc/${objName}`, option.file).then((res) => {

        this.screenshot = res.url
        // 上传成功之后，转换真实的地址
        signatureUrl(`mz_pc/${objName}`).then((res) => {

        });
      });
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.screenshot = ""
    },
    handlePreview(file) {
      this.handleShowImg = this.screenshot
      this.dialogShow = true
    },
    //截图
    handleAvatarSuccess(res, file) {

      // uploadFileToOss(file);
      // this.screenshot = URL.createObjectURL(file.raw);
    },
    handleAvatarSuccess_wx(res, file) {

    },
    getFileName_wx(name) {
      return name.substring(name.lastIndexOf("."));
    },
    beforeUpload_wx(file) {

      // 限制上传类型
      const fileExtensions =
        this.getFileName(file.name) === ".bmp" ||
        this.getFileName(file.name) === ".tif" ||
        this.getFileName(file.name) === ".gif" ||
        this.getFileName(file.name) === ".pcx" ||
        this.getFileName(file.name) === ".svg" ||
        this.getFileName(file.name) === ".psd" ||
        this.getFileName(file.name) === ".webp" ||
        this.getFileName(file.name) === ".apng" ||
        this.getFileName(file.name) === ".ai" ||
        this.getFileName(file.name) === ".avif" ||
        this.getFileName(file.name) === ".png" ||
        this.getFileName(file.name) === ".pdf"||
        this.getFileName(file.name) === ".jpg";
      //限制的上限为20M
      const max20M = file.size / 1024 / 1024 < 20;
      if (!fileExtensions) {
        this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
      }
      if (!max20M) {
        this.$message.error("上传文件大小不能超过 20MB!");
      }
      return fileExtensions && max20M;
    },
    handleUpload_wx(option) {
      // 获取文件的后缀名
      var obj = option.file.name;
      var index = obj.lastIndexOf(".");
      obj = obj.substring(index, obj.length);
      // 生成的文件名，保留文件后缀名，进行拼接
      let objName = getFileNameUUID() + this.getFileName(option.file.name);
      // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
      put(`mz_pc/${objName}`, option.file).then((res) => {

        this.flag = true;
        this.weixin = res.url
        // 上传成功之后，转换真实的地址
        signatureUrl(`mz_pc/${objName}`).then((res) => {

        });
      });
    },

    // 获取当前时间，年-月-日 时:分:秒
    getNowTime() {
        var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      hour = hour < 10 ? "0" + hour : hour;
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    },


    handleRemove_wx(file, fileList) {
      this.fileList_wx = fileList;
      this.weixin = ""
    },
    handlePreview_wx(file) {
      this.handleShowImg = this.weixin
      this.dialogShow = true
    },
    handleAvatar(res, file) {
      if (res.code == 200) {
        this.flag = true;
      }
      this.weixin = URL.createObjectURL(file.raw);
    },
    //提交
    submitForm(formName) {
      if (!this.flag && this.radio == 2) {
        this.$message.error("请上传微信二维码");
        return;
      }
      //点击客资管理显示您好，xx老师
      let adminNo = "";
      let admin = window.localStorage.getItem("admin");
      if (admin != null) {
        adminNo = JSON.parse(admin).adminNo;
      } else {
        let teacher = window.localStorage.getItem("teacher");
        if (teacher != null) {
          adminNo = JSON.parse(teacher).adminNo;
        }
      }

      let list = [];

      if(this.textareaJson){
        list = [{ remark: this.textareaJson, remarkDate: this.getNowTime() }];
      }else{
        list = [];
      }

      this.$refs[formName].validate((valid) => {
        if (valid) {


          loadingUtils.startLoading();

          axios.post(`${apiBaseUrl}/customerinformation/customerinformationadd`, {
              customerWx: this.ruleForm.customerWx,
              customerSource: this.ruleForm.customerSource,
              customerSourcepeople: this.ruleForm.customerSourcePeople,
              customerTeachername: this.ruleForm.customerTeacherid,
              regionName: this.ruleForm.customerTeacheridd,
              customerType: this.radio,
              customerIsactive: this.add,
              trafficSource:this.trafficSource,
              adminNo: this.salesteachers,
              salesteachers: this.salesteachers,
              customer_url: this.screenshot,
              customer_ewm: this.weixin,
              channelType: this.ruleForm.channelType,
              clientNeedRemark: JSON.stringify(list),
            },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {

              setTimeout(() => {
                loadingUtils.endLoading()
              }, 500)

              if (res.data.code == 200) {
                this.$message.success(res.data.message);
                this.$refs["ruleForm"].resetFields();
                this.screenshot = "";
                this.customerWx = "";
                this.weixin = "";
                this.textareaJson = "";
                this.ruleForm.customerTeacheridd = ''
                this.radio = "1";
                this.add = "1";
                this.ruleForm.channelType = ''
                this.trafficSource = '1',
                this.showWxInput = true; // 显示微信号输入框
                this.showQrCode = false; // 隐藏微信二维码上传框
                this.salesteachers = "";
                this.showSelect = false; // 显示下拉框
              } else {
                //失败
                this.$message.error(res.data.message);
                setTimeout(() => {
                  loadingUtils.endLoading()
                }, 500)
              }
            })
            .catch((error) => {
              console.error(error);
              setTimeout(() => {
                loadingUtils.endLoading()
              }, 500)
            });
        } else {

          return false;
        }
      });
    },
    // resetForm(formName) {
    //   this.$refs[formName].resetFields()
    //   this.screenshot = ''
    // },
    //客资来源
    getDataSourse() {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then((response) => {
          this.sources = response.data.data.list;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //客资来源负责人
    getDataSoursePeople() {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then((response) => {
          this.sourcesPeople = response.data.data.list;
          //
        })
        .catch((error) => {
          console.error(error);
        });
    },
    //老师ip
    getDataTeachers() {
      // axios
      //   .get(`${apiBaseUrl}/schedule/teacherlist`)
      //   .then((response) => {
      //     this.teachers = response.data.data
      //   })
      //   .catch((error) => {
      //     console.error(error)
      //   })
    },
    // 使用正则表达式去除空格和汉字
    limitation() {
      this.ruleForm.customerWx = this.ruleForm.customerWx.replace(
        /[\s\u4e00-\u9fa5]/g,
        ""
      );
    },
    //类型
    handleChange(val) {
      this.$refs["ruleForm"].resetFields();
      // 监听单选框变化的方法
      if (val === "1") {
        // 如果选中的是微信号单选框
        this.showWxInput = true; // 显示微信号输入框
        this.showQrCode = false; // 隐藏微信二维码上传框
      } else if (val === "2") {
        // 如果选中的是微信二维码单选框
        this.showWxInput = false; // 隐藏微信号输入框
        this.showQrCode = true; // 显示微信二维码上传框
      }
    },
    //添加方式
    handleChangeadd(value) {
      if (value === "2") {
        // 如果添加方式被设置为被动，显示下拉框
        this.showSelect = true;
      } else {
        // 否则隐藏下拉框
        this.showSelect = false;
      }
    },
    passivity() {
      this.add = "2"; // 设置添加方式为被动
      this.showSelect = true; // 显示下拉框
    },
  },
};
</script>
<style scoped>
/* .screenshot >>> .el-form-item__label {
  float: unset !important;
} */
.app {
  width: 100%;
  border-radius: 10px;
}

.text {
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-weight: 600;
}

.app img {
  width: 100%;
}

.body {
  padding: 15px;
  /* margin-top: 20px; */
}

.bodyy {
  margin-top: 30px;
}

.demo-ruleForm > .el-form-item {
  margin-bottom: 3.86667vw !important;
}

.input-container,
.upload-container {
  margin-bottom: 15px;
}

.num {
  font-size: 16px;
}

label {
  display: inline-block;
  margin-bottom: 5px;
}

.input {
  width: 82vw;
  height: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 16px;
}

.button {
  width: 300px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 20px;
  font-size: 16px;
}

.btn {
  width: 100%;
  height: 50px;
}

.select {
  width: 88vw;
  border: 1px solid #ccc;
  border-radius: 10px;
  font-size: 16px;
  margin-bottom: 0.66667vw;
}

.required {
  color: red;
}

.button-container {
  /* display: flex;
  justify-content: space-between; */
  text-align: center;
  margin-top: 50px;
}

/* /* .button {
  flex: 1;
  margin-right: 10px;
}  */

.submit {
  background-color: #007bff;
  color: #fff;
}

.success {
  background-color: #ccc;
  color: white;
  /* 其他样式属性 */
}

.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-right: 88%;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .el-radio-group {
    display: flex;
    padding-top: 7px;
  }

  .screenshot {
    width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/manager/CustomerCollect.vue